module.exports = __webpack_public_path__ + "img/IMG_5002_L_Foamcore_MockedUp.71df6330.jpg";